import React from 'react'
import convertToAnswerLetters from '../../../../helpers/assessment/convertToAnswerLetters';
import shortid from 'shortid'

export default function CorrectAnswersRow({answers}) {
  
  return (
    <tr className="whiteBG">
      <th colSpan="2">Correct Answers</th>
      {
        answers.map((answer, n) => 
          <td key={shortid.generate()}>{convertToAnswerLetters(n + 1, answer)}</td>
        )
      }
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentAnswerMap/CorrectAnswersRow.js